import { render } from "./Logistica.vue?vue&type=template&id=def301ae&scoped=true"
import script from "./Logistica.vue?vue&type=script&lang=js"
export * from "./Logistica.vue?vue&type=script&lang=js"

import "./Logistica.vue?vue&type=style&index=0&id=def301ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def301ae"]])

export default __exports__